<script setup>
import { WdsNavLink } from '@wds/components';

defineProps({
  tag: {
    type: String,
    required: false,
    default: 'section',
  },
});
// EVENTS
const emit = defineEmits(['viewMore']);

const { t } = useI18n();
const { isBelowMediumScreen } = useMq();

const testingStore = useTestingStore();
const isReportButtonEnabled = testingStore.hasEnabledFeature('web_report_button_enabled');

// COMPUTED
const tabItems = computed(() => {
  // TODO: add conditional statement on property totalReviews

  return [
    {
      name: 'about',
      label: t('t_ABOUT'),
    },
    {
      name: 'houserules',
      label: t('t_HOUSERULES'),
    },
    {
      name: 'location',
      label: t('t_LOCATION'),
    },
    {
      name: 'reviews',
      label: t('t_REVIEWS'),
    },
  ];
});

function tabClicked(tabInfo) {
  emit('viewMore', tabInfo.tab);
}
</script>

<template>
  <component :is="tag">
    <div class="tab-list-container">
      <div class="quick-nav-wrapper">
        <WdsNavLink
          v-for="item in tabItems"
          :key="`tab-${item.name}`"
          :label="item.label"
          :name="item.name"
          @click="tabClicked({ tab: item.name })"
        />
      </div>
      <div class="report-button">
        <CommonHwReportProperty v-if="!isBelowMediumScreen && isReportButtonEnabled" />
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.tab-list-container {
  background-color: $wds-color-ink-lightest;
  display: flex;
  margin: auto;
  padding: 0 25rem 0 0;
  justify-content: space-between;

  .quick-nav-wrapper {
    display: flex;
    gap: $wds-spacing-m;
  }

  .report-button {
    display: flex;
    align-items: center;
    padding: 0 $wds-spacing-m;
  }
}
</style>
